var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBarChartIconDisabled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 34 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n\n      .cls-2 {\n        fill: #30bc94;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Content"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 0,
    y: 0,
    width: 34,
    height: 34,
    rx: 16.88,
    ry: 16.88
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 6.51,
    y: 17.59,
    width: 6,
    height: 5,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 6.51,
    y: 10.59,
    width: 13,
    height: 5,
    rx: 1,
    ry: 1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M26.51,11.59v3h-4v-3h4m0-1h-4c-.55,0-1,.45-1,1v3c0,.55,.45,1,1,1h4c.55,0,1-.45,1-1v-3c0-.55-.45-1-1-1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M26.51,18.59v3H15.51v-3h11m0-1H15.51c-.55,0-1,.45-1,1v3c0,.55,.45,1,1,1h11c.55,0,1-.45,1-1v-3c0-.55-.45-1-1-1h0Z"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarChartIconDisabled);
export default __webpack_public_path__ + "static/media/bar-chart-icon-disabled.e4ec43a62e1fd0ff3eebd43c1a6694db.svg";
export { ForwardRef as ReactComponent };